import React from "react";
import { useTranslation } from "react-i18next";
import { useTelemetry } from "../../context/TelemetryContext";
import ModeIndicator from "../../components/shared/ModeIndicator";
import DemoDataNotice from "../../components/shared/DemoDataNotice";
import LanguageToggle from "../../components/shared/LanguageToggle";
import SubPageNav from "../../components/shared/SubPageNav";

function IncidentArchive() {
const { t } = useTranslation();

const telemetry = useTelemetry();

return (

<div
style={{
padding: "20px",
color: "white"
}}
>

<div style={{ position: "relative", textAlign: "center", marginBottom: 25 }}>
<h1 style={{ margin: 0 }}>{t("incidentArchive.title")}</h1>
<p style={{ color: "#94a3b8", marginTop: 8, fontSize: "0.9rem" }}>{t("incidentArchive.subtitle")}</p>
<div style={{ position: "absolute", top: 0, right: 0, display: "flex", alignItems: "flex-start", gap: "12px" }}><LanguageToggle /><ModeIndicator /></div>
</div>

<div
style={{
display: "grid",
gridTemplateColumns: "1fr 1fr 1fr",
gap: "20px"
}}
>

{/* Historical Review */}

<div
style={{
background: "#111827",
padding: "20px",
borderRadius: "14px",
border: "1px solid #1e293b"
}}
>

<h3>{t("incidentArchive.historicalReview.title")}</h3>

<h2 style={{ marginTop: "15px", color: "#38bdf8" }}>2,041</h2>
<p style={{ color: "#94a3b8" }}>{t("incidentArchive.historicalReview.archivedRecords")}</p>
<p style={{ color: "#475569", fontSize: "0.75rem", fontStyle: "italic" }}>{t("incidentArchive.historicalReview.demoNote")}</p>

<div style={{ marginTop: "15px" }}>
{t("incidentArchive.historicalReview.lastArchiveSync", { value: t("incidentArchive.historicalReview.activeValue") })}
</div>

</div>

{/* AI Learning Recall */}

<div
style={{
background: "#111827",
padding: "20px",
borderRadius: "14px",
border: "1px solid #1e293b"
}}
>

<h3>{t("incidentArchive.aiLearningRecall.title")}</h3>

<h2
style={{
marginTop: "15px",
color: "#22c55e"
}}
>
148
</h2>

<p style={{ color: "#94a3b8" }}>
{t("incidentArchive.aiLearningRecall.similarMatches")}
</p>

<div style={{ marginTop: "15px" }}>
{t("incidentArchive.aiLearningRecall.confidence", { value: telemetry.aiConfidence })}
</div>

</div>

{/* Forensic Timeline */}

<div
style={{
background: "#111827",
padding: "20px",
borderRadius: "14px",
border: "1px solid #1e293b"
}}
>

<h3>{t("incidentArchive.forensicTimeline.title")}</h3>

<div style={{ marginTop: "15px" }}>

<p>{t("incidentArchive.forensicTimeline.entry1")}</p>

<p>{t("incidentArchive.forensicTimeline.entry2")}</p>

<p>{t("incidentArchive.forensicTimeline.entry3")}</p>

<p>{t("incidentArchive.forensicTimeline.entry4")}</p>

</div>

</div>

</div>

{/* ===================================================== */}
{/* OPERATIONAL INTELLIGENCE LAYER */}
{/* ===================================================== */}

<div
style={{
display:"grid",
gridTemplateColumns:"1fr 1fr 1fr",
gap:"20px",
marginTop:"20px"
}}
>

{/* Operational Analytics */}

<div
style={{
background:"#111827",
padding:"20px",
borderRadius:"14px",
border:"1px solid #1e293b"
}}
>

<h3>{t("incidentArchive.operationalAnalytics.title")}</h3>

<div style={{marginTop:"15px"}}>

<p>{t("incidentArchive.operationalAnalytics.totalIncidents", { value: "2,041" })}</p>

<p>{t("incidentArchive.operationalAnalytics.criticalEvents", { value: 182 })}</p>

<p>{t("incidentArchive.operationalAnalytics.warningEvents", { value: 643 })}</p>

<p>{t("incidentArchive.operationalAnalytics.resolvedEvents", { value: "1,216" })}</p>

</div>

</div>

{/* Learning Intelligence */}

<div
style={{
background:"#111827",
padding:"20px",
borderRadius:"14px",
border:"1px solid #1e293b"
}}
>

<h3>{t("incidentArchive.learningIntelligence.title")}</h3>

<div style={{marginTop:"15px"}}>

<p>
{t("incidentArchive.learningIntelligence.lessonsLearned")}
<span style={{color:"#38bdf8"}}>
 {" "}412
</span>
</p>

<p>
{t("incidentArchive.learningIntelligence.resolvedScenarios")}
<span style={{color:"#22c55e"}}>
 {" "}1,216
</span>
</p>

<p>
{t("incidentArchive.learningIntelligence.knowledgeUpdates")}
<span style={{color:"#f59e0b"}}>
 {" "}{t("commandCenter.status.active")}
</span>
</p>

<p>
{t("incidentArchive.learningIntelligence.memoryEngine")}
<span style={{color:"#22c55e"}}>
 {t("commandCenter.status.synced")}
</span>
</p>

</div>

</div>

{/* Knowledge Base */}

<div
style={{
background:"#111827",
padding:"20px",
borderRadius:"14px",
border:"1px solid #1e293b"
}}
>

<h3>{t("incidentArchive.knowledgeBase.title")}</h3>

<div style={{marginTop:"15px"}}>

<p>{t("incidentArchive.knowledgeBase.vocEscalation")}</p>

<p>{t("incidentArchive.knowledgeBase.exposureAlert")}</p>

<p>{t("incidentArchive.knowledgeBase.multiSignalEvent")}</p>

</div>

</div>

</div>


{/* ===================================================== */}
{/* INCIDENT INTELLIGENCE DASHBOARD */}
{/* ===================================================== */}

<div
style={{
display:"grid",
gridTemplateColumns:"1fr 1fr 1fr",
gap:"20px",
marginTop:"20px"
}}
>

{/* Archived Incidents */}

<div
style={{
background:"#111827",
padding:"20px",
borderRadius:"14px",
border:"1px solid #1e293b"
}}
>

<h3>{t("incidentArchive.archivedIncidents.title")}</h3>

<div style={{marginTop:"15px"}}>

<p>INC-2041 | {t("commandCenter.risk.WARNING")}</p>
<p>INC-2038 | {t("commandCenter.risk.CRITICAL")}</p>
<p>INC-2032 | {t("commandCenter.risk.WARNING")}</p>
<p>INC-2028 | {t("commandCenter.risk.SAFE")}</p>

</div>

</div>

{/* AI Memory Agent Network */}

<div
style={{
background:"#111827",
padding:"20px",
borderRadius:"14px",
border:"1px solid #1e293b"
}}
>

<h3>{t("incidentArchive.aiMemoryAgentNetwork.title")}</h3>

<div style={{marginTop:"15px"}}>

<p style={{color:"#22c55e"}}>{t("incidentArchive.aiMemoryAgentNetwork.archiveAgent")} - {t("commandCenter.status.active")}</p>

<p style={{color:"#22c55e"}}>{t("incidentArchive.aiMemoryAgentNetwork.memoryAgent")} - {t("commandCenter.status.active")}</p>

<p style={{color:"#22c55e"}}>{t("incidentArchive.aiMemoryAgentNetwork.patternAgent")} - {t("commandCenter.status.active")}</p>

<p style={{color:"#22c55e"}}>{t("incidentArchive.aiMemoryAgentNetwork.learningAgent")} - {t("commandCenter.status.active")}</p>

<p style={{color:"#22c55e"}}>{t("incidentArchive.aiMemoryAgentNetwork.knowledgeAgent")} - {t("commandCenter.status.active")}</p>

</div>

</div>

{/* Pattern Recognition */}

<div
style={{
background:"#111827",
padding:"20px",
borderRadius:"14px",
border:"1px solid #1e293b"
}}
>

<h3>{t("incidentArchive.patternRecognition.title")}</h3>

<div style={{marginTop:"15px"}}>

<p>
{t("incidentArchive.patternRecognition.repeatedLocation")}
<span style={{color:"#38bdf8"}}>
 {" "}{t("incidentArchive.patternRecognition.classroomBlock")}

</span>
</p>

<p>
{t("incidentArchive.patternRecognition.repeatedSignal")}
<span style={{color:"#f59e0b"}}>
 {" "}{t("incidentArchive.patternRecognition.vocEscalationValue")}
</span>
</p>

<p>
{t("incidentArchive.patternRecognition.mostCommonRisk")}
<span style={{color:"#ef4444"}}>
 {" "}{t("commandCenter.risk.WARNING")}
</span>
</p>

<p>
{t("incidentArchive.patternRecognition.detectionAccuracy")}
<span style={{color:"#22c55e"}}>
 {" "}94%
</span>
</p>
<DemoDataNotice textKey="common.demoDataNotice.illustrativeFigure" />

</div>

</div>

</div>




{/* ===================================================== */}
{/* EXECUTIVE ARCHIVE SUMMARY */}
{/* ===================================================== */}

<div
style={{
marginTop:"20px",
background:"#111827",
padding:"25px",
borderRadius:"14px",
border:"1px solid #1e293b"
}}
>

<h3
style={{
textAlign:"center",
marginBottom:"20px"
}}
>
{t("incidentArchive.summary.title")}
</h3>

<p
style={{
textAlign:"center",
color:"#94a3b8",
lineHeight:"2",
maxWidth:"900px",
margin:"0 auto"
}}
>
{t("incidentArchive.summary.text")}
</p>

</div>

<SubPageNav current="incidentArchive" />

</div>

);

}

export default IncidentArchive;